import { Indicator } from '../../../Common/Charts/Indicator';
import { useDatabaseChartsDataContext } from './hooks/useDatabaseChartsDataContext';

export const AbsenceOfHomeVisitIndicator = () => {
    const { chartData } = useDatabaseChartsDataContext();

    return (
        <Indicator
            title={'Indice de Ausência de Visita Domiciliar'}
            indicatorValue={chartData?.indicators?.absenceOfHomeVisit}
            className='aligned-container'
        />
    );
};
